import React from "react";
import { MessageBar, MessageBarType } from "@fluentui/react";

export const ThirdPartyCookiesWarning = () => (
  <MessageBar messageBarType={MessageBarType.warning} isMultiline={false} styles={{root:{display: 'none'}}}>
    Silent login may fail if third-party cookies are blocked or you are in Incognito mode. 
    Please enable them or switch to a normal browser window for the best experience.
  </MessageBar>
);